import React from 'react';
import { Link } from '@lt/components';
import styles from './emailButton.module.css';

import type { EmailProvider, ProviderConfig } from './types';
import { mapProviderToConfig } from './config';

interface Props {
  email: string;
}

function mapEmailToConfig(email: string): ProviderConfig | undefined {
  const [, domain] = email.split('@');
  const provider = domain?.split('.')[0] as EmailProvider;

  return mapProviderToConfig[provider];
}

export const EmailButton: React.FC<Props> = ({ email }) => {
  const config = mapEmailToConfig(email);

  if (!config) {
    return null;
  }

  return (
    <Link className={styles.link} href={config.url}>
      {config.icon}
      <span className={styles.text}>Перейти в {config.name}</span>
    </Link>
  );
};
